<template>
    <div>
        <v-row no-gutters justify="center" class="title_bar mb-6">
            <v-col cols="11" md="10" lg="6"><h1 class="pa-1">Elérhetőségek</h1></v-col>
        </v-row>
        <v-row no-gutters justify="center">
            <v-col cols="11" md="10" lg="6">
                <v-row class="mb-2 contact">
                    <v-icon color="black" class="mx-2 icon">mdi-phone</v-icon>
                    <a href="tel:+3614560596" class="black--text mr-7">+36-1-456-0596</a>
                </v-row>
                <v-row class="my-2 contact">
                    <v-icon color="black" class="mx-2 icon">mdi-email</v-icon>
                    <a href="mailto:support@bns.hu" class="black--text mr-7">office@bns.hu</a>
                </v-row>
                <v-row class="my-2 contact">
                    <v-icon color="black" class="mx-2 icon">mdi-map-marker-radius</v-icon>
                    <a href="https://www.google.com/maps/place/BNS+M%C3%A9rn%C3%B6kiroda+Kft./@47.4793991,19.0733306,16.04z/data=!4m9!1m2!2m1!1sbns!3m5!1s0x4741dcf93ab92cdd:0xa8aa20cdde57975!8m2!3d47.4808755!4d19.072694!15sCgNibnMiA4gBAZIBE2luZHVzdHJpYWxfZW5naW5lZXI" target="_blank" class="black--text mr-7">1094 Budapest, Ferenc tér 2.</a>
                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters justify="center" class="title_bar mb-10">
            <v-col cols="11" md="10" lg="6"><h1 class="pa-1">Kérdésed van?</h1></v-col>
        </v-row>
        <v-row no-gutters justify="center" class="mb-5 mx-1">
            <v-col cols="11" md="10" lg="6">
                <v-row >
                    <v-text-field required width="50%" color="#920825" v-model="name" label="Név" outlined ></v-text-field>
                </v-row>
                <v-row>
                    <v-text-field required color="#920825" v-model="email" label="E-mail" outlined ></v-text-field>
                </v-row>
                <v-row>
                    <v-textarea required color="#920825" name="input-5-4" v-model="message" label="Üzenet" outlined ></v-textarea>
                </v-row>
                <v-row>
                    <v-btn tile @click="send" :disabled="!button_enabled" color="#920825" class="white--text px-6 mb-5">Küldés</v-btn>
                    <v-col class="pa-0 ml-5">

                        <v-alert                            
                            v-show="alert_show"
                            :type="alert_type"
                            transition="scale-transition"
                            dismissible
                            dense
                        >{{alert_message}}</v-alert>

                </v-col>
                </v-row>
                <v-row justify="center">
                
                </v-row>
            </v-col>
        </v-row>
        
    </div>
</template>
<script>
import api from "@/util/api_util"
export default {
    data() {
        return {
            expand:false,            
            name: "",
            email: "",
            message: "",
            button_enabled : true,
            alert_show : false,
            alert_message: "",
            alert_type : "success",
        }
    },

    methods:{
        send(){
            let body = {
                    name:this.name,
                    email:this.email,
                    user_message:this.message
                };
            this.button_enabled = false
            api.post("/mailsend",body).then(response=>{
                if (response.status == 200){
                    this.alert_message = response.data["message"]
                    this.alert_type = "success"
                    this.alert_show = true
                    this.name = ""
                    this.email = ""
                    this.message = ""
                    this.button_enabled = true
                    setTimeout(() =>{
                      this.alert_show = false; 
                    },5000)
                }
            })
        }
    }
}
</script>
<style scoped>
.title_bar{
        background-color: #920825;
        color: white;
    }
    a{
        font-size: 1.2rem;
        text-decoration: none;
    }
    a:hover{
        text-decoration: underline;
        text-decoration-color: black;
    }
</style>